import clsx from './clsx';
import { DNA_PHASES, phaseRailIndex } from './phaseRailIndex';
import styles from './PhaseRail.module.css';

// =============================================================================
// PhaseRail — the DNA interview's Origins → Timeline → Synthesis progress
// strip (LANE DNA-BUILD, Phase 1). Re-skinned port of apps/web/src/pages/
// Dna.tsx's inline PhaseRail fn (:452-469): same 3-phase order, same
// "complete collapses onto the last phase" rule (now a pure, unit-pinned
// function — see phaseRailIndex.ts), Tailwind classes swapped for --tl-*
// tokens per the plan's re-skin discipline
// (docs/design/dna-interview-port-2026-07-05.md §3 Phase 1).
// =============================================================================

export interface PhaseRailProps {
  phase: string;
}

export function PhaseRail({ phase }: PhaseRailProps) {
  const idx = phaseRailIndex(phase);
  return (
    <div className={styles.rail} role="list" aria-label="Interview progress">
      {DNA_PHASES.map((p, i) => (
        <div
          key={p.key}
          role="listitem"
          className={clsx(styles.step, i <= idx && styles.stepActive)}
        >
          {p.label}
        </div>
      ))}
    </div>
  );
}
